import React from 'react';
import ReactDOM from 'react-dom';
import Homepage from './pages/homepage'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'


ReactDOM.render(
  <React.StrictMode>
      <Homepage/>
  </React.StrictMode>,
  document.getElementById('root')
);

